import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {Home} from "./Home";
import {About} from "./About/About";
import {Header} from "./Header/Header";
import {Footer} from "./Footer/Footer";
import {Contact} from "./Contact/Contact";
import {DiaconuIlieCv} from "./Accounts/DiaconuIlieCv";
import {SnackbarProvider} from "notistack";
import {DiaconuIsabelleCv} from "./Accounts/DiaconuIsabelleCv";
import {Projects} from "./Projects/Projects";
import {ProjectPage} from "./Projects/ProjectPage";
import {NotFound} from "./NotFound/NotFound";

const App: React.FC = () => {
    return (
        <SnackbarProvider maxSnack={3}
                          anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center',
                          }}>
            <Header/>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:slug" element={<ProjectPage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/diaconu-ilie-cv" element={<DiaconuIlieCv />} />
                <Route path="/diaconu-isabelle-cv" element={<DiaconuIsabelleCv />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer/>
        </SnackbarProvider>
    );
};

export default App;
